import { ITypedReduxAction } from '../../../types/redux/actionType';
import { ICommentParent, IComment } from '../../../types/commentList';

export enum ESetCommentParamActionType {
  Set = 'postComments/updateCommentParam/set',
}

export interface ISetCommentParam {
  id: ICommentParent['id'] | IComment['id'];
  key: 'isJustAdded';
  value?: ICommentParent['isJustAdded'] | IComment['isJustAdded'];
}

export type TSetCommentParam = ITypedReduxAction<ESetCommentParamActionType.Set, ISetCommentParam>;
